module.exports = __webpack_public_path__ + "img/pic_brazil_05.7b7a4c96.jpg";